const SANDBOX_URL =
  "https://sandbox-checkout.izipay.pe/payments/v1/js/index.js";
const PROD_URL = "https://checkout.izipay.pe/payments/v1/js/index.js";

export function loadIzipaySdk() {
  return new Promise((resolve, reject) => {
    if (window.Izipay) return resolve(window.Izipay); // ya cargado

    const env = process.env.REACT_APP_IZIPAY_ENV || "sandbox";
    const src = env === "production" ? PROD_URL : SANDBOX_URL;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(window.Izipay);
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
